import React, { useState } from 'react';
import Section from './Section';

const Contact = ({ email = 'you@example.com' }) => {
  const [status, setStatus] = useState('');

  const onSubmit = (e) => {
    e.preventDefault();
    setStatus('Thanks! I will get back to you shortly.');
    e.target.reset();
  };

  return (
    <Section id="contact" title="Contact" subtitle="Let's work together">
      <div className="grid two">
        <div>
          <p className="muted">Feel free to reach out for collaborations or just a friendly hello 👋</p>
          <a className="btn primary" href={`mailto:${email}`}>Email me</a>
        </div>
        <form className="card glass form" onSubmit={onSubmit}>
          <div className="row two">
            <label>
              <span>Name</span>
              <input type="text" name="name" placeholder="Your name" required />
            </label>
            <label>
              <span>Email</span>
              <input type="email" name="email" placeholder="you@example.com" required />
            </label>
          </div>
          <label>
            <span>Message</span>
            <textarea name="message" rows="4" placeholder="Tell me about your project..." required />
          </label>
          <button className="btn primary" type="submit">Send Message</button>
          {status && <p className="success small">{status}</p>}
        </form>
      </div>
    </Section>
  );
};

export default Contact;
